export const AddMoreFormOptionsProducts = [
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select Quality",
    isRequired: true,
    valueLabel: "quality", //to select correct value for field
    options: [
      { value: "firstQuality", label: "First Quality", type: "quality" },
      { value: "secondQuality", label: "Second Quality", type: "quality" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "number",
    labelName: "Price(Rs)",
    placeholder: "Enter price",
    isRequired: true,
    valueLabel: "price", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "number",
    labelName: "Discount amount",
    placeholder: "Discount amount",
    isRequired: false,
    valueLabel: "discount_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "select",
    labelName: "Discount Type",
    placeholder: "Discount Type",
    isRequired: false,
    valueLabel: "discount_type", //to select correct value for field
    options: [
      { value: "flat", label: "Flat", type: "discount_type" },
      { value: "%", label: "%", type: "discount_type" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },

  {
    type: "date",
    labelName: "Effect From",
    placeholder: "Effect From",
    isRequired: false,
    valueLabel: "effect_from", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "date",
    labelName: "Effect To",
    placeholder: "Effect To",
    isRequired: false,
    valueLabel: "effect_to", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
];
export const AddMoreFormOptionsProduction = [
  {
    type: "select",
    labelName: "Quality",
    placeholder: "Select Quality",
    isRequired: false,
    valueLabel: "quality", //to select correct value for field
    options: [
      { value: "firstQuality", label: "First Quality", type: "quality" },
      { value: "secondQuality", label: "Second Quality", type: "quality" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Price(Rs)",
    placeholder: "Enter price",
    isRequired: false,
    valueLabel: "price", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Discount amount",
    placeholder: "Discount amount",
    isRequired: false,
    valueLabel: "discount_amount", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "select",
    labelName: "Discount Type",
    placeholder: "Discount Type",
    isRequired: false,
    valueLabel: "discount_type", //to select correct value for field
    options: [
      { value: "flat", label: "Flat", type: "discount_type" },
      { value: "%", label: "%", type: "discount_type" },
    ],
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },

  {
    type: "date",
    labelName: "Effect From",
    placeholder: "Effect From",
    isRequired: false,
    valueLabel: "effect_from", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "date",
    labelName: "Effect To",
    placeholder: "Effect To",
    isRequired: false,
    valueLabel: "effect_to", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
];

export const AddMoreFormOptionsCartoonStocks = [
  {
    type: "select",
    labelName: "Cartoon Type",
    placeholder: "Select type",
    isRequired: true,
    valueLabel: "cartoon_type", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "number",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "quantity", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "number",
    labelName: "Price Per Cartoon",
    placeholder: "Enter Price Per Cartoon",
    isRequired: true,
    valueLabel: "price_per_cartoon", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
];
export const AddMoreFormOptionsCartoonWithDraws = [
  {
    type: "number",
    labelName: "Product Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "product_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Cartoon Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "cartoon_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "date",
    labelName: "Production Date",
    placeholder: "Enter Date",
    isRequired: false,
    valueLabel: "production_date", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "select",
    labelName: "Product Quality",
    placeholder: "Select quality",
    isRequired: false,
    valueLabel: "product_quality", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
];

export const AddMoreFormOptionsPlasticStocks = [
  {
    type: "select",
    labelName: "Plastic Type",
    placeholder: "Select type",
    isRequired: false,
    valueLabel: "plastic_type", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "text",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "quantity", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Price Per Plastic",
    placeholder: "Enter Price Per Plastic",
    isRequired: false,
    valueLabel: "price_per_plastic", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    labelStyle: "!inline-block",
  },
];
export const AddMoreFormOptionsPlasticWithDraws = [
  {
    type: "number",
    labelName: "Product Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "product_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "number",
    labelName: "Plastic Quantity",
    placeholder: "Enter quantity",
    isRequired: true,
    valueLabel: "plastic_qty", //to select correct value for field
    labelStyle: "!inline-block",
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "date",
    labelName: "Production Date",
    placeholder: "Enter Date",
    isRequired: true,
    valueLabel: "production_date", //to select correct value for field
    CustomInputStyle: "w-[46%] !inline-block mr-2", //css to adjust two element side by side
  },
  {
    type: "select",
    labelName: "Product Quality",
    placeholder: "Select quality",
    isRequired: true,
    valueLabel: "product_quality", //to select correct value for field
    labelStyle: "!inline-block",
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
];

export const AddMoreFormOptionsLeafStocks = [
  {
    type: "select",
    labelName: "Leaf Type",
    placeholder: "Select type",
    isRequired: false,
    valueLabel: "leaf_type", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "text",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Price Per Leaf",
    placeholder: "Enter Price Per Leaf",
    isRequired: false,
    valueLabel: "price_per_leaf", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Mileage",
    placeholder: "Enter mileage",
    isRequired: false,
    valueLabel: "mileage", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
    repeatType: true,
  },
  {
    type: "text",
    labelName: "Distance Travel",
    placeholder: "Enter distance travel",
    isRequired: false,
    valueLabel: "distance_travel", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
  {
    type: "text",
    labelName: "Hiring Cost",
    placeholder: "Enter hiring cost",
    isRequired: false,
    valueLabel: "hiring_cost", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
];

export const AddMoreFormOptionsStickerStocks = [
  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select type",
    isRequired: false,
    valueLabel: "vendor_id", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[100%] !inline-block mr-2",
  },
  {
    type: "text",
    labelName: "Quantity",
    placeholder: "Enter quantity",
    isRequired: false,
    valueLabel: "quantity", //to select correct value for field
    CustomInputStyle: "w-[93%]  mr-2", //css to adjust two element side by side
  },
];
